import {makeAutoObservable, observable} from 'mobx'


export default class RoomModel {
    constructor() {
        makeAutoObservable(this)
    }

    id = '';
    images = [];
    photos = [];
    description = '';
    type = '';
    title = '0';
    loading = true;
    loadingAad = false;

    room_id = ''
    rooms = observable([]);
    cart = observable([]);

}
